import { Component, OnInit } from '@angular/core';
import { OccConfig, SiteContextParamsService, TranslatePipe } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CustomerData } from 'src/app/models/customer.model';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { SpinnerComponent } from '@spartacus/storefront';
import { AsyncPipe } from '@angular/common';
import { RemoveLeadingZerosPipe } from '../../shared/pipe/kn-br-custom-pipes/remove-leading-zeros.pipe';

@Component({
    selector: 'knbr-recent-customer-result',
    templateUrl: './kn-br-recent-customer-result.component.html',
    styleUrls: ['./kn-br-recent-customer-result.component.scss'],
    imports: [SpinnerComponent, AsyncPipe, TranslatePipe, RemoveLeadingZerosPipe]
})
export class KnBrRecentCustomerResultComponent implements OnInit {
  customerResult$: Observable<CustomerData[]> = this.knBrCommonService.loadRecentCustomersList$();

  constructor(
    private knBrCommonService: KnBrCommonService,
    private customerContextService: KnBrCustomerContextService,
    protected config: OccConfig,
    protected siteContextParamsService: SiteContextParamsService,
  ) {}

  ngOnInit() {
    this.knBrCommonService.getRecentCustomersList();
  }

  storeInContext(customer: CustomerData) {
    const indexOfSite =  this.config.context.country.indexOf(customer.countryCode.toLowerCase())
    if(indexOfSite > -1) {
      const site = this.config.context.baseSite[indexOfSite];
      const currency = this.config.context.currency[indexOfSite];
      this.siteContextParamsService.setValue('baseSite', site);
      this.siteContextParamsService.setValue('currency',currency);
    }
    this.customerContextService.set(customer);
  }

  formatState(state) {
    return this.knBrCommonService.formatState(state);
  }
}
